import { Link } from '@tanstack/react-router'
import LogoIcon from './logo.svg?react'

interface LogoProps {
  to?: string
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  className?: string
}

/**
 * Reusable ModelStack logo component
 * Used in Header, Footer, Auth pages, and Dashboard
 */
export function Logo({
  to = '/',
  size = 'md',
  showText = true,
  className = '',
}: LogoProps) {
  const sizeClasses = {
    sm: { icon: 'w-8 h-8 text-xl', text: 'text-xl' },
    md: { icon: 'w-10 h-10 text-2xl', text: 'text-2xl' },
    lg: { icon: 'w-12 h-12 text-3xl', text: 'text-3xl' },
  }

  const classes = sizeClasses[size]

  const content = (
    <>
      <div
        className={`${classes.icon} flex items-center justify-center text-[var(--color-primary)] transition-[filter,transform] duration-300 ease-brisk group-hover:drop-shadow-[0_0_12px_var(--color-primary-shadow)]`}
      >
        <LogoIcon className="w-full h-full" />
      </div>
      {showText && (
        <span
          className={`${classes.text} font-bold tracking-tight text-[var(--color-text-primary)]`}
        >
          ModelStack
        </span>
      )}
    </>
  )

  return (
    <Link to={to} className={`flex items-center gap-3 group ${className}`}>
      {content}
    </Link>
  )
}
